import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import checkIcon from 'assets/images/WithoutLogin/Checkbox.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getSubscription } from 'store/subscriptionPlan/subscriptionPlanAction';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableTabs from 'components/commom/Tab';
import {
  basicDetailsValue,
  SELECT_PLAN,
} from 'store/BasicDetailValues/BasicDetailValuesAction';
import { doctorCancelWeb, doctorPayment } from 'routes/AppUrls';
import Shimmer from 'components/commom/Shimmer';
import LocalStorageManager from 'managers/LocalStorageManger';
import moment from 'moment';
import ReusableButton from 'components/commom/Button';
import CommonToast from 'components/commom/CommonToast';

const DoctorChangePlan = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const intl = useIntl();
  const params = useParams();
  const { showToast } = CommonToast();
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [tab, setTab] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectPlanId, setSelectPlanId] = useState('');

  const loading = useSelector(
    (state) => state?.profileSectionDataReducer?.loading
  );

  const profileData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const ProductDescription = ({ description }) => {
    const stripHtmlTags = (html) => {
      if (!html) return [];
      return html
        .replace(/<[^>]*>/g, '')
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '' && line !== '&nbsp;');
    };

    const lines = stripHtmlTags(description);

    const capitalizeFirstLetter = (line) => {
      if (line.length === 0) return line;
      return line.charAt(0).toUpperCase() + line.slice(1).toLowerCase();
    };

    const highlightKeywords = (text) => {
      const keywords = [
        'Name',
        'Title',
        'Practice location',
        'Listed after advanced in roster',
      ];

      keywords.forEach((keyword) => {
        const regex = new RegExp(`(${keyword})`, 'gi');
        text = text.replace(
          regex,
          '<span style="font-size:14px; font-weight:400;" class="family_outfit_regular_400">$1</span>'
        );
      });

      text = text.replace(/:\s*([^,]*),/g, ': $1');
      return text;
    };

    return (
      <div>
        {lines.map((line, index) =>
          line && line !== '&nbsp;' ? (
            <div key={index} className="flex items-start mb-2">
              {/* <Image src={checkIcon} alt="checkIcon" className="mt-1 mr-2" /> */}
              <p
                className="family_outfit_regular_400"
                style={
                  index === 0 ? { margin: 0 } : { fontSize: '16px', margin: 0 }
                }
                dangerouslySetInnerHTML={{
                  __html: highlightKeywords(line),
                }}
              />
            </div>
          ) : null
        )}
      </div>
    );
  };

  const tabData = [
    { label: intl.formatMessage({ id: 'Basic' }) },
    { label: intl.formatMessage({ id: 'Advance' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  useEffect(() => {
    LocalStorageManager.setItem('token', params?.token);
  }, []);

  useEffect(() => {
    if (subscriptionList.length > 0) {
      const selectedSubPlans =
        tab === 1
          ? subscriptionList?.[0]?.sub_plans
          : subscriptionList?.[1]?.sub_plans;
      setSelectedPlan(selectedSubPlans?.[0] || null);
    }
  }, [subscriptionList, tab]);

  useEffect(() => {
    if (LocalStorageManager.getItem('token')) {
      subscriptionPlanList();
    }
  }, []);

  const subscriptionPlanList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSubscriptionList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSubscription(external, profileData?.title?.slug));
  };

  const handleChoosePlan = (value) => {
    setSelectedPlan(value);
    setSelectPlanId(value?.subscription_plan_id);
  };

  const hanldeNavigateCurrent = () => {
    navigate(doctorCancelWeb(locale));
  };

  const hanldeNavigateCheckout = () => {
    dispatch(basicDetailsValue(SELECT_PLAN, selectedPlan));
    if (selectPlanId) {
      if (selectPlanId === params?.id) {
        showToast(
          'You cannot select the current plan. Please choose another one.',
          'warning'
        );
        return;
      } else {
        navigate(
          doctorPayment(
            locale,
            selectPlanId,
            LocalStorageManager.getItem('token')
          )
        );
      }
    } else {
      if (tab === 1) {
        if (selectedPlan?.subscription_plan_id === params?.id) {
          showToast(
            'You cannot select the current plan. Please choose another one.',
            'warning'
          );
          return;
        }
        navigate(
          doctorPayment(
            locale,
            selectedPlan?.subscription_plan_id,
            LocalStorageManager.getItem('token')
          )
        );
      } else {
        if (selectedPlan?.subscription_plan_id === params?.id) {
          showToast(
            'You cannot select the current plan. Please choose another one.',
            'warning'
          );
          return;
        }
        navigate(
          doctorPayment(
            locale,
            selectedPlan?.subscription_plan_id,
            LocalStorageManager.getItem('token')
          )
        );
      }
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <Row className="m-0">
            <Col lg={10} xl={10} xxl={10} className=" p-0">
              <div className="pt-10 lg:pt-0">
                <div class="p-16 sm:p-24 bg-light-100 border-1 bColor-EFE3D7 ">
                  <div className="pb-10 fs-24 family_outfit_semiBold_600 lh-312 fc-292D32 border-b bColor-EFE3D7">
                    Current Plans
                  </div>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-18 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Plan Type :
                    </div>
                    {loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {`${
                          profileData?.subscription?.subscription_plan?.product
                            ?.name
                        } ${profileData?.subscription?.subscription_plan?.name}`}
                      </div>
                    )}
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center pt-10"
                  >
                    <div className="fs-18 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                      Plan Price :
                    </div>
                    {profileData?.subscription?.subscription_plan?.price ===
                    undefined ? (
                      ''
                    ) : loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {`$ ${profileData?.subscription?.subscription_plan?.price}`}
                      </div>
                    )}
                  </Stack>
                  <Row className="m-0">
                    <Col
                      xs={6}
                      sm={4}
                      md={3}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="p-0"
                    >
                      <div className="fs-18 family_outfit_medium_500 lh-30 fc-A4AAB2 pt-20">
                        Active since
                      </div>
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {loading ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          moment(profileData?.subscription?.valid_from).format(
                            'DD MMM YYYY'
                          )
                        )}
                      </div>
                    </Col>
                    <Col xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                      <div className="fs-18 family_outfit_medium_500 lh-30 fc-A4AAB2 pt-20">
                        Ending date
                      </div>
                      <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                        {loading ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          moment(
                            profileData?.subscription?.next_billing_time
                          ).format('DD MMM YYYY')
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className="pt-10 fs-16 family_outfit_medium_500 lh-30 fc-292D32 flex items-center">
                    Description
                  </div>
                  <div className="pt-10">
                    {loading ? (
                      <Shimmer width="150px" height="20px" />
                    ) : (
                      <ProductDescription
                        description={
                          profileData?.subscription?.subscription_plan
                            ?.description
                        }
                      />
                    )}
                  </div>
                  <div className="pb-16 fs-24 family_outfit_semiBold_600 lh-312 fc-292D32 flex justify-content-center">
                    Subscription Plans
                  </div>

                  <Row className="p-0 flex justify-center">
                    <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                      <ReusableTabs
                        tabs={tabData}
                        defaultTab={tab}
                        currentTab={(val) => handleTabChange(val)}
                        background={'#864629'}
                        color={'#FFFFFF'}
                        tabColor={'#998A7B'}
                        completeColor={'#FFFFFF'}
                      />
                    </Col>
                  </Row>

                  <div className="pt-16">
                    {tab === 1 ? (
                      <Row className="g-4 flex justify-center">
                        {subscriptionList &&
                          subscriptionList?.length > 0 &&
                          subscriptionList?.[0]?.sub_plans.map(
                            (item, index) => {
                              return (
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={4}
                                  xl={4}
                                  xxl={4}
                                >
                                  <Card
                                    className={
                                      selectPlanId ===
                                        item?.subscription_plan_id ||
                                      selectedPlan?.subscription_plan_id ===
                                        item?.subscription_plan_id
                                        ? 'p-20  subscription-card-select cursor-pointer ...'
                                        : 'p-20 subscription-card cursor-pointer ...'
                                    }
                                    onClick={() =>
                                      handleChoosePlan(item, index)
                                    }
                                  >
                                    <Card.Body className="p-0">
                                      <Card.Title>
                                        <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                                          {loading ? (
                                            <Shimmer
                                              width="150px"
                                              height="20px"
                                            />
                                          ) : (
                                            item?.name
                                          )}
                                        </div>
                                        <div className="flex">
                                          <div className="fs-24 fc-1E1E1E family_outfit_medium_500 lh-288 pt-8">
                                            {loading ? (
                                              <Shimmer
                                                width="150px"
                                                height="20px"
                                              />
                                            ) : (
                                              `$ ${item?.price}`
                                            )}
                                          </div>
                                        </div>
                                      </Card.Title>
                                      <Card.Text>
                                        <ProductDescription
                                          description={item?.description}
                                        />
                                      </Card.Text>
                                    </Card.Body>
                                  </Card>
                                </Col>
                              );
                            }
                          )}
                      </Row>
                    ) : (
                      <Row className="g-4 flex justify-center">
                        {subscriptionList &&
                          subscriptionList?.length > 0 &&
                          subscriptionList?.[1]?.sub_plans.map(
                            (item, index) => {
                              return (
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={4}
                                  xl={4}
                                  xxl={4}
                                >
                                  <Card
                                    className={
                                      selectPlanId ===
                                        item?.subscription_plan_id ||
                                      selectedPlan?.subscription_plan_id ===
                                        item?.subscription_plan_id
                                        ? 'p-20  subscription-card-select cursor-pointer ...'
                                        : 'p-20 subscription-card cursor-pointer ...'
                                    }
                                    onClick={() =>
                                      handleChoosePlan(item, index)
                                    }
                                  >
                                    <Card.Body className="p-0">
                                      <Card.Title>
                                        <div className="fs-20 fc-1E1E1E family_outfit_semiBold_600 lh-30">
                                          {loading ? (
                                            <Shimmer
                                              width="150px"
                                              height="20px"
                                            />
                                          ) : (
                                            item?.name
                                          )}
                                        </div>
                                        <div className="flex">
                                          <div className="fs-24 fc-1E1E1E family_outfit_medium_500 lh-288 pt-8">
                                            {loading ? (
                                              <Shimmer
                                                width="150px"
                                                height="20px"
                                              />
                                            ) : (
                                              `$ ${item?.price}`
                                            )}
                                          </div>
                                        </div>
                                      </Card.Title>
                                      <Card.Text>
                                        <ProductDescription
                                          description={item?.description}
                                        />
                                      </Card.Text>
                                    </Card.Body>
                                  </Card>
                                </Col>
                              );
                            }
                          )}
                      </Row>
                    )}
                  </div>

                  <Row className="flex justify-center">
                    <Col lg={3} xl={3} xxl={3}>
                      <div className="pt-32">
                        <ReusableButton
                          fullWidth={true}
                          variant="outlined"
                          color="#375241"
                          fontSize="14px"
                          fontWeight="600"
                          padding="12px 50px"
                          height="44px"
                          bgColor="transparent"
                          brColor="#375241  "
                          fontFamily="outfit_semiBold"
                          onClick={() => hanldeNavigateCurrent()}
                        >
                          <FormattedMessage id="Cancel" />
                        </ReusableButton>
                      </div>
                    </Col>
                    <Col lg={3} xl={3} xxl={3}>
                      <div className="pt-10 md:pt-32">
                        <ReusableButton
                          fullWidth={true}
                          variant="outlined"
                          color="#F5F5F5"
                          fontSize="14px"
                          fontWeight="600"
                          padding="12px 0px"
                          height="44px"
                          bgColor="#375241"
                          brColor="#375241  "
                          fontFamily="outfit_semiBold"
                          onClick={() => hanldeNavigateCheckout()}
                        >
                          <FormattedMessage id="Continous To Checkout" />
                        </ReusableButton>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DoctorChangePlan;
